<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Course</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Course</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CourseList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Course Title</strong> {{ value.course_title }}</li>

                  <li><strong>Course Certificate Title</strong> {{ value.course_certificate_title }}</li>

                  <li><strong>Slug/URL</strong> {{ value.slug }}</li>

                  <li><strong>Summary</strong> {{ value.course_summery }}</li>

                  <li><strong>Description</strong> {{ value.description }}</li>

                  <li><strong>Related Courses</strong> {{ value.related_courses }}</li>

                  <li><strong>Course Type</strong> {{ value.course_type }}</li>

                  <li><strong>Category</strong>
                      <span v-if="!_.isNil(value.category_id)">{{ pre.category_id[value.category_id] }}</span>
                    </li>

                  <li><strong>Sub Category</strong> {{ value.sub_category_id }}</li>

                  <li><strong>Is Published</strong> {{ value.is_published }}</li>

                  <li><strong>Instructor</strong>
                      <span v-if="!_.isNil(value.instructor_id)">{{ pre.instructor_id[value.instructor_id] }}</span>
                    </li>

                  <li><strong>Course Image</strong> {{ value.course_image_path }}</li>

                  <li><strong>Intro Video</strong> {{ value.intro_video_path }}</li>

                  <li><strong>Keyword</strong> {{ value.keyword }}</li>

                  <li><strong>Tag</strong> {{ value.tag }}</li>

                  <li><strong>View Count</strong> {{ value.view_count }}</li>

                  <li><strong>Course Duration(In Minute)</strong> {{ value.course_duration }}</li>

                  <li><strong>Is Featured</strong> {{ value.is_featured }}</li>

                  <li><strong>Display Order</strong> {{ value.display_order }}</li>

                  <li><strong>Rate ref id</strong> {{ value.rate_ref_id }}</li>

                  <li><strong>Price</strong> {{ value.price }}</li>

                  <li><strong>Discount Price</strong> {{ value.discount_price }}</li>

                  <li><strong>Certificate Signature</strong> {{ value.certificate_signature }}</li>

                  <li><strong>Commission Configuration Id</strong> {{ value.commission_configuration_id }}</li>

                  <li><strong>Commission Expire Date</strong> {{ value.commission_expire_date }}</li>

                  <li><strong>Cbs Product Id</strong> {{ value.cbs_product_id }}</li>

                  <li><strong>cbs_product_callback_raw</strong> {{ value.cbs_product_callback_raw }}</li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from "@/services/api";
import axios from "axios";
const fileDownload = require("js-file-download")
import { Notification } from "element-ui";


export default {
  name: "CourseShow",
  metaInfo: {
    title: "Course | Dotlines"
  },
  data: () => ({
    value: {

    },
    pre: {
      category_id: [],instructor_id: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    categoryIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/3")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    instructorIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/4")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.categoryIdOptions().then(category_id => {
        this.pre.category_id = category_id;
      });
      await this.instructorIdOptions().then(instructor_id => {
        this.pre.instructor_id = instructor_id;
      });


      await this.getDetail(this.params.id).then(response => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function(url) {
      this.is_loading = true;
      axios.get(this.API_ASSET_UPLOAD_URL+url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({title: "Download Completed", message: "Download completed successfully", type: "success"});
        })
        .catch(error => {
          Notification.error({title: "Download Failed", message: "Failed to download", type: "error"});
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/courses/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {
          });
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
